<script setup lang="ts">
import type { Component } from 'vue';
import { NuxtLink } from '#components';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

const props = withDefaults(defineProps<{
    label: string;
    icon: Component;
    href?: string;
    disabled?: boolean;
}>(), {
    href: '',
    disabled: false,
});

const emit = defineEmits<{
    click: [event: MouseEvent];
}>();
</script>

<template>
    <TooltipProvider :delay-duration="250">
        <Tooltip>
            <TooltipTrigger as-child>
                <Button
                    v-if="href"
                    variant="ghost"
                    size="icon"
                    class="entity-row-action"
                    as-child
                >
                    <NuxtLink :to="href" :aria-label="label" @click.stop>
                        <component :is="icon" class="size-4" />
                    </NuxtLink>
                </Button>
                <Button
                    v-else
                    type="button"
                    variant="ghost"
                    size="icon"
                    class="entity-row-action"
                    :disabled="disabled"
                    :aria-label="label"
                    @click.stop="emit('click', $event)"
                >
                    <component :is="icon" class="size-4" />
                </Button>
            </TooltipTrigger>
            <TooltipContent side="top">{{ label }}</TooltipContent>
        </Tooltip>
    </TooltipProvider>
</template>
